(function() {
    'use strict';

    angular
        .module('getwellApp')
        .controller('TreatmentExperienceResponseDetailController', TreatmentExperienceResponseDetailController);

    TreatmentExperienceResponseDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'TreatmentExperienceResponse'];

    function TreatmentExperienceResponseDetailController($scope, $rootScope, $stateParams, previousState, entity, TreatmentExperienceResponse) {
        var vm = this;

        vm.treatmentExperienceResponse = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('getwellApp:treatmentExperienceResponseUpdate', function(event, result) {
            vm.treatmentExperienceResponse = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
